import { Card, Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Archivos from "../Archivos";
import DataSharev2 from "./Common/DataSharev2";

export default function OnCitaConcluidov2({cita}){
    const { t } = useTranslation();
    return (
        <Container>
            <Row>
                <Col xs="12" md={{span: 10, offset: 1}}>
                    <Card className='mt-2 mb-5 shadow-sm'>
                        <Card.Body className="p-5">
                            <DataSharev2 cita={cita} title={t('cita_concluido')} />
                            <div className="mt-3">
                                <Archivos appointmentId={cita.id} noToken={true} paciente={cita.patientDTO}/>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>        
    )
} 